import axios from 'axios';
import Constants from '../constants';
import { IReportingSetupModel, IValidationModel } from '../models';
import { APIHelper } from '../utilities/APIHelper';

export const reportingSetupModelApi = Constants.SURVEY_BUILDER_SURVEYS_API_URL + '/{surveyId}/reportingSetupModels';
export async function get(surveyId: number): Promise<IValidationModel<IReportingSetupModel>> {
	const res = await axios.get(reportingSetupModelApi.replace('{surveyId}', surveyId.toString()), { headers: { Pragma: 'no-cache' } });
	return res.data;
}

export async function save(surveyId: number, reportingSetupModel: IReportingSetupModel): Promise<IValidationModel<IReportingSetupModel>> {
	const res = await axios
		.put(reportingSetupModelApi.replace('{surveyId}', surveyId.toString()), reportingSetupModel, { headers: { Pragma: 'no-cache' } })
		.catch(APIHelper.handleValidationError);
	return res.data;
}
